// extracted by mini-css-extract-plugin
export default {"dots":"_base-dots_dots_CV9I5","dotsUnpadded":"_base-dots_dotsUnpadded_EM3FO"};